import {
    GET_CREATE_NEW_CODE_LIST,
    SET_CREATE_NEW_CODE_LIST,
    GET_CREATE_NEW_CODE_SAVE,
    SET_CREATE_NEW_CODE_SAVE
} from "./AcquisitionCodeType"

const getCreateNewCodeList = (payload?: any) => ({
    type: GET_CREATE_NEW_CODE_LIST,
    payload
});

const setCreateNewCodeList = (createNewCodeList: any) => ({
    type: SET_CREATE_NEW_CODE_LIST,
    createNewCodeList: createNewCodeList
});

const getCreateNewCodeSave = (payload?: any) => ({
    type: GET_CREATE_NEW_CODE_SAVE,
    payload
});

const setCreateNewCodeSave = (createNewCodeSave: any) => ({
    type: SET_CREATE_NEW_CODE_SAVE,
    createNewCodeSave: createNewCodeSave
});

export {
    getCreateNewCodeList,
    setCreateNewCodeList,
    getCreateNewCodeSave,
    setCreateNewCodeSave
}
